import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { resetEditorProposal } from "@context/useAssignmentProposalStore";
import { PROPOSAL_ID_PARAM, REVIEW_PARAM } from "@utils/assignmentProposal";
import { requestLinkSessionsReload } from "../utils/linkSessionsReload";

/**
 * The editor shows the link's current schedule, as a regular entry: the proposal is forgotten, the
 * URL loses its proposal parameters without a history entry (so a reload does not open it again)
 * and the link data is reloaded. With `reload: false` another flow reloads the link (the
 * instructor-removal modal does it when it is closed).
 */
export const useReturnToCurrentSchedule = () => {
  const history = useHistory();

  return useCallback(
    ({ reload = true }: { reload?: boolean } = {}) => {
      const location = history.location;
      const params = new URLSearchParams(location.search);
      params.delete(PROPOSAL_ID_PARAM);
      params.delete(REVIEW_PARAM);
      const search = params.toString();

      history.replace({ ...location, search: search ? `?${search}` : "" });
      resetEditorProposal();
      if (reload) requestLinkSessionsReload();
    },
    [history],
  );
};
